import React, { useEffect, useState, ChangeEvent, StrictMode } from "react";
import { NavigationLinkProps } from "@uitk/react/types";
import { createGlobalStyle } from "styled-components";
import {
  Label,
  Heading,
  Text,
  Button,
  Panel,
  Card,
  Dialog,
  LoadingIndicator,
  Footer,
  getNativeProps,
  anchorProperties,
  Notification
} from "@uitk/react";
import styled from "styled-components";
import "../PayorDeny/PayorDenyStyles.css";
import { Link as LinkPages, useLocation, useNavigate } from "react-router-dom";
import { usePageVisit } from "../Welcome/PageVisited";
import { apiResponseInterface, RESPONSE_TYPES } from "@models/index";
import { apiWrapper, ServerError, apiRequest, apiRequestPost } from "@services/api-wrapper";
import { COREAPP_CONFIG_DIRECTORY } from "../../config";
import { coreData } from "@store/index";

const GlobalStyles = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
  }
  html, body, #react-root {
    height: 100%;
  }
`;

const OverlayWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

const StoryWrapperNavBar = styled.div`
  position: absolute;
  height: 1000px;
  width: 20%;
  background-color: aqua;
  transition: width 0.8s ease-in-out;
  .openNavBar {
    width: 0%;
  }
`;

const StoryWrapper = styled.div`
  background-color: ${(props) => props.theme.UitkSemanticColorBgCanvas};
  padding: 16px 20px 2px;
  display: flex;
  .uitk-button {
    margin-right: 15px;
    // margin-top: 10px;
  }
  .displayPageNumber {
    margin: 0px 10px 0px 0px !important;
    line-height: 40px !important;
  }
`;

const StoryWrapperGrid = styled.div`
  .demo-content {
    border-left: 1px solid #888b8d;
    color: #000000;
    margin: 0px 0px: 0px: 0px;
  }
`;

const StoryWrapperSideContent = styled.div`
  .searchBox {
    outline: 1px solid rgba(255, 255, 255, 1);
    text-align: center;
  }

  .dataTableTitle {
    text-align: center;
  }
  // .item1 {
  //   width: 50%
  // }
  .topGap40 {
    margin-top: 8px;
  }
  .panel2 {
    color: rgb(75, 77, 79);
    line-height: 1.5rem;
    font-size: 1.125rem;
    text-decoration: none;
  }
`;

const StoryWrapperBreadCrumb = styled.div`
  .breadcrumbHome {
    color: rgba(54, 123, 245, 1);
    height: auto;
    text-decoration: none;
  }
  .breadcrumbHome:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const ProcedureDiagnosis: React.FC = () => {
  const { incrementLoader, decrementLoader } = coreData();
  const [listRecords, setListRecords] = useState([])

  const RoutableLink: React.FC<NavigationLinkProps> = (item) => {
    const { url, children } = item;
    const anchorProps = getNativeProps(item, anchorProperties);
    return (
      <LinkPages to={url} {...anchorProps}>
        {children}
      </LinkPages>
    );
  };

  const [loading, setLoading] = useState(false);
  const { handlePageVisited } = usePageVisit();

  const currentRoute = useLocation();

  useEffect(() => {
    handlePageVisited({
      path: currentRoute.pathname,
      title: "Procedure Diagnosis",
      summary: "Review edit for procedure diagnosis code combinations",
    });
  }, []);

  const logo = (
    <img
      src="https://www.optum.com/content/dam/optum4/images/logos/optum-logo-ora-rgb1.svg"
      className="uitk-footer__logo--small uitk-footer__logo--medium uitk-footer__logo--large"
      alt="logo"
    />
  );
  const linkConfig = {
    links: [
      {
        href: "https://www.optum.com/about-us.html",
        label: "About Us",
        openInNewTab: true,
      },
      {
        href: "https://www.optum.com/contact-us.html",
        label: "Contact Us",
        openInNewTab: true,
      },
      {
        href: "https://www.optum.com/more-optum-sites.html",
        label: "More Optum Sites",
        openInNewTab: true,
      },
    ],
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const currentYear = new Date().getFullYear();

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setScreenHeight(window.innerHeight);
      setScreenWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [dateCode, setDateCode] = useState(currentDate);

  const handleCode1 = (event: ChangeEvent<HTMLInputElement>) => {
    setCode1(event.target.value);
  };

  const handleCode2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode2(event.target.value);
  };

  const handleDateCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDateCode(event.target.value);
  };

  let [informationGrids, setInformationGrids] = useState([
    <>
      <div className="dataGridContainer-colums4">
        <div className="dataGrid boldCell">Procedure Code:</div>
        <div className="dataGrid">
          <span id="code1Begin"></span>
        </div>
        <div className="dataGrid boldCell">Diagnosis Code:</div>
        <div className="dataGrid">
          <span id="code1BeginDesc"></span>
        </div>
      </div>

      <div className="dataGridContainer-colums2">
        <div className="dataGrid boldCell">Description:</div>
        <div className="dataGrid">
          <span id="modifOverride"></span>
        </div>
      </div>
      <div className="dataGridContainer-colums4">
        <div className="dataGrid boldCell">Effective Start Date:</div>
        <div className="dataGrid">
          <span id="effStartDate"></span>
        </div>
        <div className="dataGrid boldCell">Effective End Date:</div>
        <div className="dataGrid">
          <span id="effEndDate"></span>
        </div>
      </div>
    </>,
  ]);

  let [sourcesGrids, setSourcesGrids] = useState([
    <>
      <div className="dataGrid boldCell dataTableTitle">Source</div>
      <div className="dataGrid boldCell dataTableTitle">Source Year</div>
      <div className="dataGrid boldCell dataTableTitle">Source Month</div>
      <div className="dataGrid boldCell dataTableTitle">Additional Info.</div>
      <div className="dataGrid boldCell dataTableTitle">
        Effective Start Date
      </div>
      <div className="dataGrid boldCell dataTableTitle">Effective End Date</div>
    </>,
  ]);

  let [editRationaleStatementText, setEditRationaleStatementText] =
    useState("");

  let [beginPageNumberDisplay, setBeginPageNumberDisplay] = useState("XX");
  let [endPageNumberDisplay, setEndPageNumberDisplay] = useState("XX");
  var [beginPageNumber, setBeginPageNumber] = useState(0);
  var [endPageNumber, setEndPageNumber] = useState<number | undefined>(0);

  let sourceGrids: JSX.Element[] = [];

  let [viewAllCodesGrids, setViewAllCodesGrids] = useState<JSX.Element[]>([]);
  let updateContent: JSX.Element[] = [];
  let [textElement, setTextElement] = useState(null);

  type ErrorMessage = {
    title: string;
    details: string;
    action: {
      label: string;
      handler: () => void;
    };
  };

  const [error, setError] = useState<ErrorMessage | null>(null);
  const [errorDisplay, setErrorDisplay] = useState("");

    /**
   * This is triggered on everytime success and it just resets the success notification
   */
    const [notificationData, setNotificationData] = useState({
      type: "",
      message: "",
      id: "",
      show: false,
    });
  
    useEffect(() => {
      if (notificationData.show) {
        setTimeout(
          () =>
            setNotificationData({
              type: "",
              message: "",
              id: "",
              show: false,
            }),
          COREAPP_CONFIG_DIRECTORY.NOTICATION_RESET_AFTER_MS
        );
      }
    }, [notificationData.show]);
  function apiCleanUpHandler() {
    // setLoading((curr) => !curr);
    // //setzIndexLoading(-1);
  }

  function apiErrorHandler(error: Error) {
    decrementLoader()
    if (error instanceof ServerError) {
      switch (error.code) {
        case 401:
          setError({
            title: "Unauthorized Access",
            details: error.message,
            action: {
              label: "Reauthenticate",
              handler: () => {
                navigate("/");
              },
            },
          });
          break;
        default:
          clearSearchResults('')
          setNotificationData({
            type: "error",
            id: "notification_success",
            show: true,
            message: COREAPP_CONFIG_DIRECTORY.STATIC_TEXT_CONFIG.DATA_NOT_FOUND,
          });
          break;
      }
    } else if (error instanceof TypeError) {
      clearSearchResults('')
      setNotificationData({
        type: "error",
        id: "notification_success",
        show: true,
        message: COREAPP_CONFIG_DIRECTORY.STATIC_TEXT_CONFIG.API_ERROR_MESSAGE,
      }); 
        setLoading(false);
        //setzIndexLoading(-1);
    }
  }

  const apiURL = `${process.env.REACT_APP_BASE_API_URL}`;

  const navigate = useNavigate();
  const makeAPICall = async (
    endpoint: string,
    successHandler: (response: apiResponseInterface) => void
  ) => {
    try {
      const resp = await apiWrapper.post(endpoint, null);

      if (resp.responseType === RESPONSE_TYPES.API_SUCCESS) {
        decrementLoader()
        successHandler(resp);
      } else if (resp.responseType === RESPONSE_TYPES.API_FAILED) {
        decrementLoader()
        switch (resp.responseCode) {
          case 401:
            navigate("/Logout");
            break;
        }
      }
    } catch (error) {
      decrementLoader()
      console.error("error handler arm...", error);
    } finally {
      decrementLoader()
      // setLoading((curr) => !curr);
      // //setzIndexLoading(-1);
    }
  };

  async function viewAllCodes() {
    setErrorDisplay("");
    const dataLink =
      `${apiURL}/api/v1/erm/storedproc/procedureDiagnosisProcedure/list?Procedurecode=` +
      code1 +
      "&DiagnosisCode=" +
      code2 +
      "&Querydate=" +
      dateCode;

    await apiRequestPost({
      endpoint: dataLink,
      successHandler: (resp) => {
        decrementLoader()
        const resultVAC = resp.responseData;
        if (resultVAC.length > 8) {
          setTextElement(
            <Label style={{ float: `right`, marginTop: "8px" }}>
              {resultVAC.length} results found
            </Label>
          );
        }
        setListRecords(resultVAC);
        setEndPageNumber(resultVAC.length);

        if(resultVAC.length > 0) {
          fetchRecordForDetails(resultVAC)
        }

        for (let i = 0; i < resultVAC.length; i++) {
          let j = i * 3 + 1;
          const k = resultVAC[i].PROCEDURE_CODE;
          const l = resultVAC[i].DIAGNOSIS_CODE;
          updateContent.push(
            <>
              <div
                key={j}
                onClick={() => loadPanelData(k, l, dateCode, i + 1)}
                className="cursorHover linkColor"
              >
                <span>{i + 1}</span>
              </div>
              <div
                key={j + 1}
                onClick={() => loadPanelData(k, l, dateCode, i + 1)}
                className="cursorHover"
              >
                {resultVAC[i].PROCEDURE_CODE}
              </div>
              <div
                key={j + 2}
                onClick={() => loadPanelData(k, l, dateCode, i + 1)}
                className="cursorHover"
              >
                {resultVAC[i].DIAGNOSIS_CODE}
              </div>
            </>
          );
        }
        setViewAllCodesGrids(updateContent);
      },
      errorHandler: apiCleanUpHandler,
      cleanUpHandler: () => {
        decrementLoader();
      },
    });
  }

  async function pageUp() {
  incrementLoader('Fetching ...')
    beginPageNumber++;
    setBeginPageNumber(beginPageNumber); //this updates the page count to display on UI

    let pageUpDwnCode1 = listRecords.length > 0 ? listRecords[beginPageNumber - 1]?.PROCEDURE_CODE : code1
    let pageUpDwnCode2 = listRecords.length > 0 ? listRecords[beginPageNumber - 1]?.DIAGNOSIS_CODE : code2

    if (pageUpDwnCode2 === undefined) {
      pageUpDwnCode2 = ''
    }

    const dataLink =
      `${apiURL}/api/v1/erm/storedproc/procedureDiagnosisProcedure?Procedurecode=` +
      pageUpDwnCode1 +
      "&DiagnosisCode=" +
      pageUpDwnCode2 +
      "&Querydate=" +
      dateCode +
      "&start=1" +
      // beginPageNumber +
      "&size=1";

    await makeAPICall(dataLink, (resp) => {
      decrementLoader()
      let result = resp.responseData;

      let updatedInformationGrids = [
        <>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Procedure Code:</div>
            <div className="dataGrid">
              <span id="code1Begin">{result.reponse[0][0].PROCEDURE_CODE}</span>
            </div>
            <div className="dataGrid boldCell">Diagnosis Code:</div>
            <div className="dataGrid">
              <span id="code1BeginDesc">
                {result.reponse[0][0].DIAGNOSIS_CODE}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums2">
            <div className="dataGrid boldCell">Description:</div>
            <div className="dataGrid">
              <span id="modifOverride">
                {result.reponse[0][0].DIAGNOSIS_CODE_DESCRIPTION}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Effective Start Date:</div>
            <div className="dataGrid">
              <span id="effStartDate">
                {result.reponse[0][0].EFFECTIVE_DATE}
              </span>
            </div>
            <div className="dataGrid boldCell">Effective End Date:</div>
            <div className="dataGrid">
              <span id="effEndDate">
                {result.reponse[0][0].EFFECTIVE_EXPIRATION_DATE}
              </span>
            </div>
          </div>
        </>,
      ];
      setInformationGrids(updatedInformationGrids);

      for (let i = 0; i < result.reponse[0].length; i++) {
        let j = i * 6 + 1;
        sourceGrids.push(
          <>
            <div className="dataGrid" key={j}>
              {result.reponse[0][i].SOURCE_CODE}
            </div>
            <div className="dataGrid" key={j + 1}>
              {result.reponse[0][i].KB_SOURCE_YEAR}
            </div>
            <div className="dataGrid" key={j + 2}>
              {result.reponse[0][i].KB_SOURCE_MONTH}
            </div>
            <div className="dataGrid" key={j + 3}>
              {result.reponse[0][i].KB_SOURCE_INFO}
            </div>
            <div className="dataGrid" key={j + 4}>
              {result.reponse[0][i].EDIT_SOURCE_EFFECTIVE_DATE}
            </div>
            <div className="dataGrid" key={j + 5}>
              {result.reponse[0][i].EDIT_SOURCE_EXPIRATION_DATE}
            </div>
          </>
        );
      }
      let updatedSourcesGrids = [
        <>
          <div className="dataGrid boldCell dataTableTitle">Source</div>
          <div className="dataGrid boldCell dataTableTitle">Source Year</div>
          <div className="dataGrid boldCell dataTableTitle">Source Month</div>
          <div className="dataGrid boldCell dataTableTitle">
            Additional Info.
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective Start Date
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective End Date
          </div>
        </>,
        ...sourceGrids,
      ];
      setSourcesGrids(updatedSourcesGrids);

      let descStatement = result.reponse[0][0].DISCLOSURE;
      descStatement = descStatement.replaceAll("\r\n", "\n");
      setEditRationaleStatementText(descStatement);

     decrementLoader()
    });
  }

  async function pageDown() {
  incrementLoader('Fetching ...')
    beginPageNumber--;
    setBeginPageNumber(beginPageNumber); //this updates the page count to display on UI

    // const [listRecords, setListRecords] = useState([])
    // setListRecords(resultVAC);
    let pageUpDwnCode1 = listRecords.length > 0 ? listRecords[beginPageNumber - 1]?.PROCEDURE_CODE : code1
    let pageUpDwnCode2 = listRecords.length > 0 ? listRecords[beginPageNumber - 1]?.DIAGNOSIS_CODE : code2

    if (pageUpDwnCode2 === undefined) {
      pageUpDwnCode2 = ''
    }

    const dataLink =
      `${apiURL}/api/v1/erm/storedproc/procedureDiagnosisProcedure?Procedurecode=` +
      pageUpDwnCode1 +
      "&DiagnosisCode=" +
      pageUpDwnCode2 +
      "&Querydate=" +
      dateCode +
      "&start=1" +
      //beginPageNumber +
      "&size=1";

    await makeAPICall(dataLink, (resp) => {
      decrementLoader()
      let result = resp.responseData;

      let updatedInformationGrids = [
        <>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Procedure Code:</div>
            <div className="dataGrid">
              <span id="code1Begin">{result.reponse[0][0].PROCEDURE_CODE}</span>
            </div>
            <div className="dataGrid boldCell">Diagnosis Code:</div>
            <div className="dataGrid">
              <span id="code1BeginDesc">
                {result.reponse[0][0].DIAGNOSIS_CODE}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums2">
            <div className="dataGrid boldCell">Description:</div>
            <div className="dataGrid">
              <span id="modifOverride">
                {result.reponse[0][0].DIAGNOSIS_CODE_DESCRIPTION}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Effective Start Date:</div>
            <div className="dataGrid">
              <span id="effStartDate">
                {result.reponse[0][0].EFFECTIVE_DATE}
              </span>
            </div>
            <div className="dataGrid boldCell">Effective End Date:</div>
            <div className="dataGrid">
              <span id="effEndDate">
                {result.reponse[0][0].EFFECTIVE_EXPIRATION_DATE}
              </span>
            </div>
          </div>
        </>,
      ];
      setInformationGrids(updatedInformationGrids);

      for (let i = 0; i < result.reponse[0].length; i++) {
        let j = i * 6 + 1;
        sourceGrids.push(
          <>
            <div className="dataGrid" key={j}>
              {result.reponse[0][i].SOURCE_CODE}
            </div>
            <div className="dataGrid" key={j + 1}>
              {result.reponse[0][i].KB_SOURCE_YEAR}
            </div>
            <div className="dataGrid" key={j + 2}>
              {result.reponse[0][i].KB_SOURCE_MONTH}
            </div>
            <div className="dataGrid" key={j + 3}>
              {result.reponse[0][i].KB_SOURCE_INFO}
            </div>
            <div className="dataGrid" key={j + 4}>
              {result.reponse[0][i].EDIT_SOURCE_EFFECTIVE_DATE}
            </div>
            <div className="dataGrid" key={j + 5}>
              {result.reponse[0][i].EDIT_SOURCE_EXPIRATION_DATE}
            </div>
          </>
        );
      }
      let updatedSourcesGrids = [
        <>
          <div className="dataGrid boldCell dataTableTitle">Source</div>
          <div className="dataGrid boldCell dataTableTitle">Source Year</div>
          <div className="dataGrid boldCell dataTableTitle">Source Month</div>
          <div className="dataGrid boldCell dataTableTitle">
            Additional Info.
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective Start Date
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective End Date
          </div>
        </>,
        ...sourceGrids,
      ];
      setSourcesGrids(updatedSourcesGrids);

      let descStatement = result.reponse[0][0].DISCLOSURE;
      descStatement = descStatement.replaceAll("\r\n", "\n");
      setEditRationaleStatementText(descStatement);

     decrementLoader()
    });
  }

  async function testApi() {
  incrementLoader('Fetching ...')
    setTextElement(null);
    beginPageNumber = 1;
    setBeginPageNumber(1);
    await viewAllCodes();
  }

  const fetchRecordForDetails = async (resultsList: any) => {
    let pageUpDwnCode1 = resultsList.length > 0 ? resultsList[0]?.PROCEDURE_CODE : code1
    let pageUpDwnCode2 = resultsList.length > 0 ? resultsList[0]?.DIAGNOSIS_CODE : code2

    if (pageUpDwnCode2 === undefined) {
      pageUpDwnCode2 = ''
    }

    const dataLink =
      `${apiURL}/api/v1/erm/storedproc/procedureDiagnosisProcedure?Procedurecode=` +
      pageUpDwnCode1 +
      "&DiagnosisCode=" +
      pageUpDwnCode2 +
      "&Querydate=" +
      dateCode +
      "&start=1&size=1";

    await apiRequestPost({
      endpoint: dataLink,
      successHandler: (resp) => {
        decrementLoader()
        const result = resp.responseData;

        setBeginPageNumberDisplay(beginPageNumber.toString());
        setEndPageNumberDisplay(result.pagenation.count);
        // setEndPageNumber(listRecords.length);

        let updatedInformationGrids = [
          <>
            <div className="dataGridContainer-colums4">
              <div className="dataGrid boldCell">Procedure Code:</div>
              <div className="dataGrid">
                <span id="code1Begin">
                  {result.reponse[0][0].PROCEDURE_CODE}
                </span>
              </div>
              <div className="dataGrid boldCell">Diagnosis Code:</div>
              <div className="dataGrid">
                <span id="code1BeginDesc">
                  {result.reponse[0][0].DIAGNOSIS_CODE}
                </span>
              </div>
            </div>
            <div className="dataGridContainer-colums2">
              <div className="dataGrid boldCell">Description:</div>
              <div className="dataGrid">
                <span id="modifOverride">
                  {result.reponse[0][0].DIAGNOSIS_CODE_DESCRIPTION}
                </span>
              </div>
            </div>
            <div className="dataGridContainer-colums4">
              <div className="dataGrid boldCell">Effective Start Date:</div>
              <div className="dataGrid">
                <span id="effStartDate">
                  {result.reponse[0][0].EFFECTIVE_DATE}
                </span>
              </div>
              <div className="dataGrid boldCell">Effective End Date:</div>
              <div className="dataGrid">
                <span id="effEndDate">
                  {result.reponse[0][0].EFFECTIVE_EXPIRATION_DATE}
                </span>
              </div>
            </div>
          </>,
        ];
        setInformationGrids(updatedInformationGrids);

        for (let i = 0; i < result.reponse[beginPageNumber - 1].length; i++) {
          let j = i * 6 + 1;
          sourceGrids.push(
            <>
              <div className="dataGrid" key={j}>
                {result.reponse[0][i].SOURCE_CODE}
              </div>
              <div className="dataGrid" key={j + 1}>
                {result.reponse[0][i].KB_SOURCE_YEAR}
              </div>
              <div className="dataGrid" key={j + 2}>
                {result.reponse[0][i].KB_SOURCE_MONTH}
              </div>
              <div className="dataGrid" key={j + 3}>
                {result.reponse[0][i].KB_SOURCE_INFO}
              </div>
              <div className="dataGrid" key={j + 4}>
                {result.reponse[0][i].EDIT_SOURCE_EFFECTIVE_DATE}
              </div>
              <div className="dataGrid" key={j + 5}>
                {result.reponse[0][i].EDIT_SOURCE_EXPIRATION_DATE}
              </div>
            </>
          );
        }
        let updatedSourcesGrids = [
          <>
            <div className="dataGrid boldCell dataTableTitle">Source</div>
            <div className="dataGrid boldCell dataTableTitle">Source Year</div>
            <div className="dataGrid boldCell dataTableTitle">Source Month</div>
            <div className="dataGrid boldCell dataTableTitle">
              Additional Info.
            </div>
            <div className="dataGrid boldCell dataTableTitle">
              Effective Start Date
            </div>
            <div className="dataGrid boldCell dataTableTitle">
              Effective End Date
            </div>
          </>,
          ...sourceGrids,
        ];
        setSourcesGrids(updatedSourcesGrids);

        let descStatement = result.reponse[0][0].DISCLOSURE;
        descStatement = descStatement.replaceAll("\r\n", "\n");
        setEditRationaleStatementText(descStatement);
      },
      errorHandler: apiErrorHandler,
      cleanUpHandler: apiCleanUpHandler,
    });
    setLoading((curr) => !curr);
    //setzIndexLoading(-1);
  };

  const clearSearchResults = (type: string) => {

    setInformationGrids([
      <>
      <div className="dataGridContainer-colums4">
        <div className="dataGrid boldCell">Procedure Code:</div>
        <div className="dataGrid">
          <span id="code1Begin"></span>
        </div>
        <div className="dataGrid boldCell">Diagnosis Code:</div>
        <div className="dataGrid">
          <span id="code1BeginDesc"></span>
        </div>
      </div>

      <div className="dataGridContainer-colums2">
        <div className="dataGrid boldCell">Description:</div>
        <div className="dataGrid">
          <span id="modifOverride"></span>
        </div>
      </div>
      <div className="dataGridContainer-colums4">
        <div className="dataGrid boldCell">Effective Start Date:</div>
        <div className="dataGrid">
          <span id="effStartDate"></span>
        </div>
        <div className="dataGrid boldCell">Effective End Date:</div>
        <div className="dataGrid">
          <span id="effEndDate"></span>
        </div>
      </div>
    </>,
    ])

    setSourcesGrids([
      <>
      <div className="dataGrid boldCell dataTableTitle">Source</div>
      <div className="dataGrid boldCell dataTableTitle">Source Year</div>
      <div className="dataGrid boldCell dataTableTitle">Source Month</div>
      <div className="dataGrid boldCell dataTableTitle">Additional Info.</div>
      <div className="dataGrid boldCell dataTableTitle">
        Effective Start Date
      </div>
      <div className="dataGrid boldCell dataTableTitle">Effective End Date</div>
    </>,
    ])

    setEditRationaleStatementText("")

    if(type === 'full') {
      setCode1('')
    }

    setTextElement(null)
    setViewAllCodesGrids([])
    setBeginPageNumber(0)
    setEndPageNumber(0)
  }


  async function loadPanelData(
    newCode1: string,
    newCode2: string,
    newDateCode: string,
    tempPageNumber: number
  ) {
  incrementLoader('Fetching ...')
  
  let Code2 = newCode2
  if (Code2 === undefined) {
    Code2 = ''
  }

    let dataLink =
      `${apiURL}/api/v1/erm/storedproc/procedureDiagnosisProcedure?Procedurecode=` +
      newCode1 +
      "&DiagnosisCode=" +
      Code2 +
      "&Querydate=" +
      dateCode +
      "&start=1" +
      //tempPageNumber +
      "&size=1";

    await makeAPICall(dataLink, (resp) => {
      decrementLoader()
      const result = resp.responseData;

      beginPageNumber = tempPageNumber;
      setBeginPageNumber(tempPageNumber);
      setBeginPageNumberDisplay(tempPageNumber.toString());
      setEndPageNumberDisplay(result.pagenation.count);

      let updatedInformationGrids = [
        <>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Procedure Code:</div>
            <div className="dataGrid">
              <span id="code1Begin">{result.reponse[0][0].PROCEDURE_CODE}</span>
            </div>
            <div className="dataGrid boldCell">Diagnosis Code:</div>
            <div className="dataGrid">
              <span id="code1BeginDesc">
                {result.reponse[0][0].DIAGNOSIS_CODE}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums2">
            <div className="dataGrid boldCell">Description:</div>
            <div className="dataGrid">
              <span id="modifOverride">
                {result.reponse[0][0].DIAGNOSIS_CODE_DESCRIPTION}
              </span>
            </div>
          </div>
          <div className="dataGridContainer-colums4">
            <div className="dataGrid boldCell">Effective Start Date:</div>
            <div className="dataGrid">
              <span id="effStartDate">
                {result.reponse[0][0].EFFECTIVE_DATE}
              </span>
            </div>
            <div className="dataGrid boldCell">Effective End Date:</div>
            <div className="dataGrid">
              <span id="effEndDate">
                {result.reponse[0][0].EFFECTIVE_EXPIRATION_DATE}
              </span>
            </div>
          </div>
        </>,
      ];
      setInformationGrids(updatedInformationGrids);

      sourceGrids = [];
      for (let i = 0; i < result.reponse[0].length; i++) {
        let j = i * 6 + 1;
        sourceGrids.push(
          <>
            <div className="dataGrid" key={j}>
              {result.reponse[0][i].SOURCE_CODE}
            </div>
            <div className="dataGrid" key={j + 1}>
              {result.reponse[0][i].KB_SOURCE_YEAR}
            </div>
            <div className="dataGrid" key={j + 2}>
              {result.reponse[0][i].KB_SOURCE_MONTH}
            </div>
            <div className="dataGrid" key={j + 3}>
              {result.reponse[0][i].KB_SOURCE_INFO}
            </div>
            <div className="dataGrid" key={j + 4}>
              {result.reponse[0][i].EDIT_SOURCE_EFFECTIVE_DATE}
            </div>
            <div className="dataGrid" key={j + 5}>
              {result.reponse[0][i].EDIT_SOURCE_EXPIRATION_DATE}
            </div>
          </>
        );
      }
      let updatedSourcesGrids = [
        <>
          <div className="dataGrid boldCell dataTableTitle">Source</div>
          <div className="dataGrid boldCell dataTableTitle">Source Year</div>
          <div className="dataGrid boldCell dataTableTitle">Source Month</div>
          <div className="dataGrid boldCell dataTableTitle">
            Additional Info.
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective Start Date
          </div>
          <div className="dataGrid boldCell dataTableTitle">
            Effective End Date
          </div>
        </>,
        ...sourceGrids,
      ];
      setSourcesGrids(updatedSourcesGrids);

      let descStatement = result.reponse[0][0].DISCLOSURE;
      descStatement = descStatement.replaceAll("\r\n", "\n");
      setEditRationaleStatementText(descStatement);

     decrementLoader()
    });
  }

  return (
    <>
      <GlobalStyles />
      {/* <OverlayWrapper style={{ zIndex: zIndexLoading }}>
        <LoadingIndicator
          loading={loading}
          displayOverlay={true}
          size="l"
          loadingText="Loading, please wait..."
        ></LoadingIndicator>
        {Boolean(error) && (
          <Dialog title={error.title} onClose={error.action.handler}>
            <Dialog.Body>
              <Text>{error.details}</Text>
            </Dialog.Body>
            <Dialog.Actions>
              <Button onPress={error.action.handler}>
                {error.action.label}
              </Button>
            </Dialog.Actions>
          </Dialog>
        )}
      </OverlayWrapper> */}
      <div className={loading ? "globalLoadingScreens" : ""}></div>
      <div className="fillerBox">
      <div className="containerTitle">
              <h1>Procedure Diagnosis</h1>
              <StoryWrapper>
                <Text className="displayPageNumber">
                <span style={{color: 'red'}}>{errorDisplay} &nbsp;&nbsp;</span>
                  Displaying <span id="beginPageNumber">{beginPageNumber}</span>{" "}
                  of <span id="endPageNumber">{endPageNumber}</span>
                </Text>
                <Button
                  variant="tertiary"
                  className="buttonTest"
                  disabled={beginPageNumber <= 1}
                  onPress={pageDown}
                >
                  Prev
                </Button>
                <Button
                  variant="tertiary"
                  disabled={beginPageNumber >= endPageNumber}
                  onPress={pageUp}
                >
                  Next
                </Button>
              </StoryWrapper>
            </div>
      </div>
      <div className="templateContainer">
      <Notification
          className="mv-m"
          variant={notificationData.type}
          id={notificationData.id}
          show={notificationData.show}
        >
          {notificationData.message}
        </Notification>
        <div className="mainSideContainer">
          {/* <StoryWrapperBreadCrumb className="breadcrumbContainer">
            <Text size="large">
              <LinkPages to="/" className="breadcrumbHome">
                Home &nbsp; &gt;
              </LinkPages>
            </Text>
            <Text size="large">Procedure Diagnosis</Text>
          </StoryWrapperBreadCrumb> */}
          <div className="searchBoxContainer searchBox2">
            <Card className="searchBox">
            <div className="codeRow1" id={screenWidth < 1322 ? '' : 'flex'}>
                <div className="item1">
                  <Label>Procedure Code</Label>
                  <input
                    type="text"
                    id="code1"
                    onChange={handleCode1}
                    value={code1}
                  />
                </div>
                <div className="item1">
                  <Label className="mr-base mt-sm">Diagnosis Code</Label>
                  <input
                    type="text"
                    id="code2"
                    onChange={handleCode2}
                    value={code2}
                  />
                </div>
              </div>
              <div className="codeRow1" id={screenWidth < 1205 ? '' : 'flex'}>
                <div className={"item1 " + (screenWidth < 1205 ? '' : 'width50')}>
                  <Label className="mr-base mt-sm">Date</Label>
                  <div id="flex">
                    <input
                      type="date"
                      id="dateCode"
                      onChange={handleDateCode}
                      value={dateCode}
                    />
                  </div>
                </div>
              </div>
              <div className="codeRow1" id={screenWidth < 1205 ? '' : 'flex'}>
              <div className="item1 buttonBox">
                  <Button disabled={code1.trim().length < 1 && code2.trim().length < 1} onPress={() => testApi()}>Search</Button>
              </div>
              <div className="item1 buttonBox">
                  <Button variant="secondary" onPress={() => clearSearchResults('full')}>Clear</Button>
              </div>
              </div>
            </Card>
          </div>
          <div className="searchBoxContainer topGap">
            <StoryWrapperSideContent>
              <Card className="searchBox">
              <h1>Search Results</h1>
                <StoryWrapperGrid>
                  <div className="dataGridContainer-colums3 topGap40 allowScroll">
                    <div className="dataGrid boldCell dataTableTitle positionSticky">#</div>
                    <div className="dataGrid boldCell dataTableTitle positionSticky">
                      Procedure Code
                    </div>
                    <div className="dataGrid boldCell dataTableTitle positionSticky">
                      Diagnosis Code
                    </div>

                    {viewAllCodesGrids}
                  </div>
                  {textElement}
                </StoryWrapperGrid>
              </Card>
              {/* <Card className="topGap">
                <Text className="topGap40">
                CPT © {currentYear} American Medical Association. All Rights Reserved.
                </Text>
              </Card> */}
            </StoryWrapperSideContent>
          </div>
        </div>
        <div className="mainContainer">
          <div>
         
            <Panel.Group>
              <Panel titleAs="h2" title="Information">
                {informationGrids}
              </Panel>
              <Panel title="Sources">
                <StoryWrapperGrid>
                  <div className="dataGridContainer-colums6">
                    {sourcesGrids}
                  </div>
                </StoryWrapperGrid>
              </Panel>
              <Panel title="Edit Rationale Statement" initiallyClosed={false}>
                <Text
                  size="medium"
                  id="ERStatement"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {editRationaleStatementText}
                </Text>
              </Panel>
            </Panel.Group>
          </div>
        </div>
      </div>
    </>
  );
};
